import { ApiClient } from './client'
import {
  POST_CONTENT_LIKE_HISTORIES,
  DELETE_CONTENT_LIKE_HISTORY,
} from './endpoints'

export const createContentLike = async (contentId: number) => {
  const body = {
    content_id: contentId,
  }
  const res = await ApiClient.post(POST_CONTENT_LIKE_HISTORIES, body)
  return res
}

export const deleteContentLike = async (contentId: number) => {
  const res = await ApiClient.delete(DELETE_CONTENT_LIKE_HISTORY(contentId))
  return res
}
